<div
  *ngIf="view && view.data"
  class="edit-frame"
  [ngClass]="{ 'is-saving': isSaving }">
  <div class="breadcrumb-holder">
    <span>
      <a routerLink="/data-models/{{ view?.type }}">{{
        view?.type | friendlyType
      }}</a>
      <span class="breadcrumb-seperator">
        <i class="fas fa-chevron-right" style="font-size: 10px"></i>
      </span>
      <span>{{ view?.mode }}</span>
    </span>
  </div>
  <div class="scaffold-page-buttons">
    <button pButton severity="secondary" (click)="cancel()">
      {{ 'cancel' | translation }}
    </button>
    <button
      pButton
      severity="primary"
      icon="fas fa-save"
      [label]="isSaving ? 'Saving...' : 'Save'"
      [loading]="isSaving"
      class="pull-right"
      (click)="savePage()"></button>
  </div>

  <div>
    <div class="form-field">
      <input
        pInputText
        placeholder="Friendly Name"
        [(ngModel)]="view.data.title" />
    </div>
  </div>

  <div class="saving-screen-cover">
    <div>
      <p>{{ 'saving' | translation }}...</p>
      <scaffold-loading-animation></scaffold-loading-animation>
    </div>
  </div>
</div>
<p-tabs value="editor">
  <p-tablist>
    <p-tab value="editor">Editor</p-tab>
    <p-tab value="json">JSON Data</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="editor">
      <app-editor
        *ngIf="view"
        [parentView]="view"
        [info]="view"
        [undoService]="undoService"
        [(items)]="content"
        [parents]="[{ type: 'editor' }]"
        [data]="{}"></app-editor>
    </p-tabpanel>
    <p-tabpanel value="json">
      <scaffold-json-editor
        *ngIf="view?.data"
        [(json)]="_content"
        [readonly]="false"></scaffold-json-editor>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
